export default __webpack_public_path__ + "media/images/images_v2/danger-df36405a156746aa4afbc6277dd055c3.png";